module.exports = __webpack_public_path__ + "media/images/icons/pdf-f3831cbe6c1df90a2582f58a15604d44.svg";